import { useEffect, useState } from 'react';
import type { ImageFilter } from '@ox/schema';
import { bakeImageFilter } from '../lib/imageFilters';

/** Small filtered preview for the effects grid. */
export function FilterThumb({ src, filter }: { src: string; filter: ImageFilter }) {
  const [url, setUrl] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    if (!src) {
      setUrl(null);
      return;
    }
    if (filter === 'none') {
      setUrl(src);
      return;
    }
    const i = new Image();
    i.crossOrigin = 'anonymous';
    i.onload = () => {
      if (cancelled) return;
      // Downscale for thumb speed
      const max = 72;
      const scale = Math.min(1, max / Math.max(i.naturalWidth || 1, i.naturalHeight || 1));
      const w = Math.max(1, Math.round((i.naturalWidth || 1) * scale));
      const h = Math.max(1, Math.round((i.naturalHeight || 1) * scale));
      const c = document.createElement('canvas');
      c.width = w;
      c.height = h;
      const ctx = c.getContext('2d');
      if (!ctx) {
        setUrl(src);
        return;
      }
      ctx.drawImage(i, 0, 0, w, h);
      const baked = bakeImageFilter(c, filter);
      setUrl(baked instanceof HTMLCanvasElement ? baked.toDataURL('image/jpeg', 0.7) : src);
    };
    i.onerror = () => {
      if (!cancelled) setUrl(src);
    };
    i.src = src;
    return () => {
      cancelled = true;
    };
  }, [src, filter]);

  return (
    <span className="ox-filter-thumb">
      {url ? <img src={url} alt="" /> : <span className="ox-filter-thumb-ph" />}
    </span>
  );
}
